import { createTranslations } from '@npco/common-utils-translations'

export const deliveryAddressReviewTranslations = createTranslations({
  addressTitle: 'Delivery Address',
  streetLabel: 'Address',
  suburbLabel: 'Suburb',
  stateLabel: 'State',
  postcodeLabel: 'Postcode',
})
